export const environment = {
  production: true,
  splixerUrl: 'https://api.splixer.com/player_api/v2/',
  defaultStationCode: "3772aabf-d521-4e8b-996e-21151dd64401",
  defaultGaTrackingId: 'G-MKRNJ95YR8',
};
